import { getToken } from "firebase/messaging";
import { getFirebaseMessaging } from "../firebase";

const validateEnv = () => {
  const required = [
    "REACT_APP_FIREBASE_API_KEY",
    "REACT_APP_FIREBASE_AUTH_DOMAIN",
    "REACT_APP_FIREBASE_PROJECT_ID",
    "REACT_APP_FIREBASE_MESSAGING_SENDER_ID",
    "REACT_APP_FIREBASE_APP_ID",
    "REACT_APP_FIREBASE_VAPID_KEY",
  ];

  const missing = required.filter((key) => !process.env[key]);
  if (missing.length > 0) {
    console.error("FCM: Missing environment variables:", missing);
    return false;
  }
  return true;
};

export const generateFcmToken = async () => {
  try {
    if (!validateEnv()) return null;

    const messaging = await getFirebaseMessaging();
    if (!messaging) return null;

    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      console.warn("FCM: Notification permission not granted");
      return null;
    }

    let serviceWorkerRegistration;
    if ("serviceWorker" in navigator) {
      try {
        const swUrl = new URL("/firebase-messaging-sw.js", window.location.origin);
        swUrl.searchParams.set("apiKey", process.env.REACT_APP_FIREBASE_API_KEY);
        swUrl.searchParams.set("authDomain", process.env.REACT_APP_FIREBASE_AUTH_DOMAIN);
        swUrl.searchParams.set("projectId", process.env.REACT_APP_FIREBASE_PROJECT_ID);
        swUrl.searchParams.set("messagingSenderId", process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID);
        swUrl.searchParams.set("appId", process.env.REACT_APP_FIREBASE_APP_ID);

        serviceWorkerRegistration = await navigator.serviceWorker.register(swUrl.toString(), {
          scope: "/",
        });
      } catch (swError) {
        console.error("FCM: Service Worker registration failed:", swError);
        return null;
      }
    }

    const token = await getToken(messaging, {
      vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
      serviceWorkerRegistration,
    });
    return token || null;
  } catch (error) {
    console.error("FCM: Token generation failed:", error);
    return null;
  }
};